import React, { useState, useRef } from 'react';
import { styled } from 'styled-components';

import star from '@src/asset/img/star.png';
import wildcard from '@src/asset/img/wildcard.png';
import missingimg from '@src/asset/img/missingimg.png';

import { useLayoutEffect } from 'react';

export const colors = [
  'rgba(98, 0, 1, 1)',
  'rgba(0, 98, 1, 1)',
  'rgba(0, 1, 98, 1)',
  'rgba(98, 98, 98, 1)',
];

const IconContainer = styled.div`
  width: 5rem;
  height: 100%;
  min-width: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;

  align-items: center;
  gap: 5pt;
`;

const PlayerContainer = styled.div`
  display: flex;
  // flex-grow: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;

const PlayerStats = styled.div<{ color: string; hasPoolScore: boolean }>`
  display: flex;
  // flex-grow: 1;
  flex-direction: row;
  align-items: center;
  align-content: center;
  align-text: center;
  justify-content: ${(props) =>
    props.hasPoolScore ? 'space-between' : 'flex-start'};
  flex-wrap: nowrap;

  // padding: 4pt;
  width: 20rem;
  max-height: 2.5rem;

  margin-left: 5pt;

  color: white;
  background-color: ${(props) => props.color};

  border: 4pt solid black;
  border-top: 2pt solid black;
  border-bottom: 2pt solid black;
`;

const Container = styled.div`
  display: flex;
  // flex-grow: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;

  // padding: 4pt;
  // // margin-bottom: 5pt;
  min-width: 25rem;
  max-width: 25rem;
  max-height: 4rem;

  color: white;
`;

const PlayerName = styled.div<{ hasPoolScore: boolean }>`
  margin-right: 0.5rem;

  min-width: ${(props) => (props.hasPoolScore ? '6.5rem' : '8rem')};
  max-width: ${(props) => (props.hasPoolScore ? '6.5rem' : '8rem')};

  font-size: 1rem;

  white-space: nowrap;
  overflow: hidden;
`;

const Cards = styled.div`
  margin-right: 0.5rem;
  font-size: 1rem;

  white-space: nowrap;
  overflow: hidden;

  min-width: 2.5rem;
  max-width: 2.5rem;
`;

const Score = styled.div`
  margin-right: 0.5rem;
  font-size: 1rem;

  white-space: nowrap;
  overflow: hidden;

  min-width: 3rem;
  max-width: 3rem;
`;

const PoolScore = styled.div`
  font-size: 1rem;

  white-space: nowrap;
  overflow: hidden;

  min-width: 3rem;
  max-width: 3rem;
`;

const IconImg = styled.img`
  max-height: 1.5rem;
  width: auto;
`;

const Avatar = styled.img`
  max-height: 2.5rem;
  width:auto;
  aspect-ratio: 1/1;
  margin-right: 5pt;
  border: 1pt solid black;
  object-fit: cover;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
`;

const TimerBar = styled.div<{ percentage: number }>`
  width: ${(props) => props.percentage}%;
  min-height: 5pt;
  max-height: 5pt;
  height: 5pt;
  background-color: yellow;
  flex:1;
  margin-left: 5pt;
  border: 4pt solid black;
  border-top: 2pt solid black;
  border-bottom: 2pt solid black;
`;

const TimerWrapper = ({
  expiresAt,
  intervalMs,
}: { expiresAt: number; intervalMs: number }) => {
  const startTime = useRef(Date.now());
  const [percent, setPercent] = useState(0);

  useLayoutEffect(() => {
    const useTimer = setInterval(() => {
      if (Date.now() < expiresAt) {
        const maxTime = expiresAt - startTime.current;
        const currentTime = Date.now() - startTime.current;
        setPercent((currentTime / maxTime) * 100);
      } else {
        setPercent(100);
      }
    }, intervalMs);

    return () => {
      clearInterval(useTimer);
    };
  }, []);
  return <TimerBar percentage={percent} />;
};

type Props = {
  index: number;
  name: string;
  numCards: number;
  avatarUrl: string;
  score: number;
  color: string;
  currentPlayerTurn: number | null;
  playerId: string;
  rowPlayerId: string;
  playerChoosingColor: string | null;
  rowPlayerDisconnected: boolean;
  currentPlayerTurnExpiresAt: number | null;
  poolScore?: number;
};

export default function Row(props: Props) {
  const [avatar, setAvatar] = useState<string | typeof missingimg>(
    props.avatarUrl,
  );

  const currentPlayerTurnExpiresAt =
    props.currentPlayerTurnExpiresAt != null
      ? props.currentPlayerTurnExpiresAt
      : Date.now();

  return (
    <Container>
      <IconContainer>
        {props.index === props.currentPlayerTurn && <IconImg src={star} />}
        {props.playerChoosingColor === props.rowPlayerId && (
          <IconImg src={wildcard} />
        )}
      </IconContainer>

      <PlayerContainer>
        <PlayerStats
          color={props.rowPlayerDisconnected ? 'gray' : props.color}
          hasPoolScore={props.poolScore !== undefined}
        >
          <Avatar
            src={avatar || missingimg}
            onError={() => setAvatar(missingimg)}
            crossOrigin='anonymous'
          />
          <PlayerName hasPoolScore={props.poolScore !== undefined}>
            {props.playerId === props.rowPlayerId && 'You - '} {props.name}
          </PlayerName>
          <Cards>🂠 {props.numCards}</Cards>
          <Score>✫ {props.score}</Score>
          {props.poolScore !== undefined && (
            <PoolScore>✭ {props.poolScore}</PoolScore>
          )}
        </PlayerStats>

        {props.currentPlayerTurnExpiresAt &&
          props.index === props.currentPlayerTurn && (
            <TimerWrapper
              expiresAt={currentPlayerTurnExpiresAt}
              intervalMs={1000}
            />
          )}
      </PlayerContainer>
    </Container>
  );
}
